import React from "react";
import ContentLoader from 'react-content-loader'

const ChartLoader = props => (
    <ContentLoader
        speed={props.speed ? props.speed : 1}
        width={props.width}
        height={props.width}
        viewBox={`0 0 ${props.width} ${props.height}`}
        overflow="hidden"
        backgroundColor="#eaeced"
        foregroundColor="#ffffff"
        {...props}
    >
        <rect x="241" y="179" rx="0" ry="0" width="25" height="40"/>
        <rect x="271" y="164" rx="0" ry="0" width="25" height="55"/>
        <rect x="301" y="145" rx="0" ry="0" width="25" height="74"/>
        <rect x="331" y="99" rx="0" ry="0" width="25" height="120"/>
        <rect x="361" y="161" rx="0" ry="0" width="25" height="58"/>
    </ContentLoader>
)

export default ChartLoader